import { Controller } from "@hotwired/stimulus"

export default class EthereumController extends Controller {
  static values = {
    fromAccount: String,
    toAccount: String,
    amount: String,
    nftNumber: String,
  }

  async transferEth() {
    if (globalThis.ethereum === undefined) {
      return Swal.fire({
        customClass: {
          popup: 'eth-install-popup swal-popup alert-sm-bg align-items-center justify-content-center w-100',
          htmlContainer: 'text-black-paint text-white'
        },
        animation: false,
        title: "Install MetaMask",
        html: `<a class="text-white-paint text-primary fs-30" href='https://metamask.io/download' target='_blank' rel='noopener noreferrer'>Install Now</a>`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    const hexValue = await globalThis.ethereum.request({"method": "eth_getBalance", "params": [this.fromAccountValue, "latest"]});
    if(hexValue){
      const accountBalance = (Number(BigInt(hexValue)) / 1e18)

      if (accountBalance >= Number.parseFloat(this.amountValue)){
        try {
          const txHash = await globalThis.ethereum.request({
            method: 'eth_sendTransaction',
            params: [{
              from: this.fromAccountValue,
              to: this.toAccountValue,
              value: '0x'+BigInt(Math.floor(this.amountValue * 1e18)).toString(16)
            }]
          })

          if(txHash){

            const response = await fetch(`/nfts/${this.nftNumberValue}/purchase`, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector("[name='csrf-token']").content
              }
            })

            if(response.ok){
              Swal.fire({
                customClass: {
                  popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
                  htmlContainer: 'text-black-paint text-white'
                },
                animation: false,
                html: "Nft purchased successfully",
                icon: "success",
                showCloseButton: true,
                buttonsStyling: false,
                showConfirmButton: false,
                timer: 2000
              })
              globalThis.location.href = "/nfts"
            }
          }
        } catch (error) {
          console.error(error)
          Swal.fire({
            customClass: {
              popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
              htmlContainer: 'text-black-paint text-white'
            },
            animation: false,
            html: "Transaction failed",
            icon: "error",
            showCloseButton: true,
            buttonsStyling: false,
            showConfirmButton: false,
            timer: 2000
          })
        }
      } else {
        $("#walletError").text('There is not enough balance in your account.')
        $("#walletError").removeClass('d-none')
      }
    }
  }
}
